import { render, staticRenderFns } from "./CameraSummaryRouter.vue?vue&type=template&id=0b457538"
import script from "./CameraSummaryRouter.vue?vue&type=script&lang=ts"
export * from "./CameraSummaryRouter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports